module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnPgogICAgICAgIDxwYXRoIGZpbGw9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSJyZWQiIGQ9Ik0xNyAyaDNhMSAxIDAgMCAxIDEgMXYxOGExIDEgMCAwIDEtMSAxSDRhMSAxIDAgMCAxLTEtMVYzYTEgMSAwIDAgMSAxLTFoM1YwaDJ2Mmg2VjBoMnYyem0wIDJ2MmgtMlY0SDl2Mkg3VjRINXYxNmgxNFY0aC0yek03IDhoMTB2Mkg3Vjh6bTAgNGgxMHYySDd2LTJ6Ii8+CiAgICA8L2c+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Menu/Todo.svg
// module id = 1972
// module chunks = 7